import { ApiBlueprint, discoveryApiRef } from '@backstage/frontend-plugin-api';
import { ArgoCDApiClient, argoCDApiRef, oidcAuthApiRef } from '../api';
import { configApiRef } from '@backstage/core-plugin-api';

/**
 * @alpha
 */
export const argoCDApiExtension = ApiBlueprint.make({
  params: paramsFactory =>
    paramsFactory({
      api: argoCDApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oidcAuthApi: oidcAuthApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oidcAuthApi, configApi }) =>
        new ArgoCDApiClient({
          discoveryApi,
          oidcAuthApi,
          backendBaseUrl: configApi.getString('backend.baseUrl'),
          useNamespacedApps: Boolean(
            configApi.getOptionalBoolean('argocd.namespacedApps'),
          ),
          searchInstances: Boolean(
            configApi.getOptionalConfigArray('argocd.appLocatorMethods')
              ?.length,
          ),
        }),
    }),
});
